import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "square-meters",
  "use": "square-meters-usage",
  "viewBox": "0 0 32.2 32.8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32.2 32.8\" id=\"square-meters\"><path d=\"M0 0v32.6h14.2v-1.2h-2.7v-6h-1.2v6H1.1V20.1H12V9.9h-1.1V19H1.1V1.1h9.8v2.8H12V1.1h19.1v12.2H21V5.5h-1.1v15.7H21v-6.8h10.1v17.2H21v-3h-1.1v4.2h12.3V0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol